import React from 'react';

function Footer() {
	return (
		<footer className="px-4 py-8 sm:px-12 md:px-16 max-w-7xl  mx-auto md:text-center font-light text-sm text-primary/60">
			<nav className="py-2">
				<ul className="flex flex-row gap-8 flex-wrap items-center [&>*:hover]:underline [&>*]:cursor-pointer [&>*]:underline-offset-4 [&>*]:py-1 list-disc">
					<a
						href="https://www.github.com/kimbohlovette"
						target="_blank"
					>
						<li>Github</li>
					</a>
					<a
						href="https://www.twitter.com/kimbohlovette"
						target="_blank"
					>
						<li>Twitter</li>
					</a>
					<a
						href="https://www.linkedin.com/in/kimbohlovette/"
						target="_blank"
					>
						<li>LinkedIn</li>
					</a>
				</ul>
			</nav>
			<p className="text-center">&copy;All rights reserved.</p>
		</footer>
	);
}

export default Footer;
